function getPropBySearchProp(ArrayToSearch, PropToSearch, PropValue, Return) {
  const data = ArrayToSearch.find(
    (Object) => Object[PropToSearch] === PropValue
  );
  return data && data[Return] ? data[Return] : "undefined";
}

module.exports = getPropBySearchProp;
